import * as Toolkit from '../../../toolkit';
import * as UIToolkit from '../../../UIToolkit';
import CreateGoodsImgUI from './createGoodsImgUI';

interface CreateGoodsImgDomParams {
    imgMap: FreeObjMap,
    direction: number,
    rotate: number,
    width: number,
    height: number,
    depth: number
}

// 组装主商品dom对象
function createGoodsDom(cube: CubeNode, renderData: FreeObjMap): JQuery<HTMLElement> {
    // 组装单个商品dom对象
    let $singleGoods: JQuery<HTMLElement> = createSingleGoods(renderData);
    let singleGoods: any = $singleGoods.get(0);

    // 用单个商品对象组装面宽、面高商品集合
    let $result: JQuery<HTMLElement> = createGoodsGroup(singleGoods, renderData);

    return $result;
}

// 组装单个商品dom对象
function createSingleGoods(goodsUIRenderData: FreeObjMap): JQuery<HTMLElement> {
    let $result: JQuery<HTMLElement> = createGoodsContiner(goodsUIRenderData);
    let $goodsImgUI: JQuery<HTMLElement> = CreateGoodsImgUI({
        width: goodsUIRenderData.width,
        height: goodsUIRenderData.height,
        direction: goodsUIRenderData.direction,
        rotate: goodsUIRenderData.rotate,
        imgMap: goodsUIRenderData.imgMap,
        wareBoxedImgMap: goodsUIRenderData.wareBoxedImgMap,
        boxSpec: goodsUIRenderData.boxSpec
    });
    let goodsItem: HTMLElement = document.createElement('div');
    let $skuItem: JQuery<HTMLElement> = $(goodsItem).addClass('goods-item');

    $skuItem.css({
        width: '100%',
        height: '100%',
        position: 'relative'
    }).append($goodsImgUI);
    $result.append($skuItem);

    return $result;
}

/**
 * 用单个商品对象组装面宽、面高商品集合
 *
 * @param {JQuery<HTMLElement>} $singleGoods 单个商品dom对象
 * @return {JQuery<HTMLElement>} 商品集合dom对象
 */
function createGoodsGroup(singleGoods: any, goodsUIRenderData: FreeObjMap): JQuery<HTMLElement> {
    let result: any = document.createElement('div');
    let rowTemplate: any = document.createElement('ul');
    let offset: number = 0;

    rowTemplate.className = 'main-goods-row';

    if (goodsUIRenderData.posWidth) {
        offset = goodsUIRenderData.posWidth;
    }

    for (let i: number = 0; i < goodsUIRenderData.row; i++) {
        let tempRow: any = rowTemplate.cloneNode(true);

        for (var c: number = 0; c < goodsUIRenderData.col; c++) {
            if (goodsUIRenderData.posWidth && c < goodsUIRenderData.col - 1) {
                let singleGoodsClone: any = singleGoods.cloneNode(true);

                singleGoodsClone.style.marginRight = `${Toolkit.cmToPx(offset)}px`;
                tempRow.appendChild(singleGoodsClone);
            }
            else {
                tempRow.appendChild(singleGoods.cloneNode(true));
            }
        }

        result.appendChild(tempRow);
    }

    return $(result).children();
}

// 创建单个商品容器dom对象
function createGoodsContiner(goodsUIRenderData: FreeObjMap): JQuery<HTMLElement> {
    let goodsColor: HTMLElement = document.createElement('span');
    let $goodsColor: JQuery<HTMLElement> = $(goodsColor).addClass('shelvesbuild-e-g-default__goods-color');
    let td: HTMLElement = document.createElement('li');
    let $result: JQuery<HTMLElement> = $(td);

    if (UIToolkit.isTxTModel() || UIToolkit.isColorModel()) {
        // 主商品背景色块显示
        $goodsColor.removeClass('hide').addClass('show');
    }
    else {
        // 主商品背景色块隐藏
        $goodsColor.removeClass('show').addClass('hide');
    }

    $goodsColor.css({
        background: goodsUIRenderData.lightColor.background
    });
    $result.addClass('goods-table-td').css({
        width: Toolkit.cmToPx(goodsUIRenderData.width),
        height: Toolkit.cmToPx(goodsUIRenderData.height),
        background: goodsUIRenderData.background
    }).append($goodsColor);

    return $result;
}

export default createGoodsDom;
